import ActionLists from "./actionLists.service";

const actionListsModule = angular
  .module("app.services.actionLists", [])
  .service("ActionLists", ActionLists);

export default actionListsModule;



// WEBPACK FOOTER //
// ./src/services/actionLists/actionLists.module.js